import type { RootState } from '@store/store';

export const getIsLoadingOnboardingSetupSelector = (state: RootState) =>
  state.onboardingSetup.isLoadingOnboardingSetup;

export const getOnboardingCompleteSelector = (state: RootState) =>
  state.onboardingSetup.onboardingSetupComplete;
export const getOnboardingSetupDataSelector = (state: RootState) => state.onboardingSetup.onboardingSetupData;

// ----------- tooltips ---------------
export const getOnboardingTooltipSelector = (state: RootState) => state.onboardingSetup.tooltips;
